import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import TitleHome from "../Utils/TitleHome";
import classes from "./About.module.css";

const AmbitionsHome = () => {
  const [demoData, setDemoData] = useState([]);
  const { debug, lang } = useContext(Context);

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  return (
    <>
      <section
        id="ambitionsHome"
        className={classes.bgAmbitions + " section p_zero"}
      >
        <div className="text-left py-5">
          <div className="container row m-auto">
            <div className="col-md-6" style={{ textAlign: "left" }}>
              <TitleHome text="Ambitions = ()" color="white" />

              <div style={{ marginLeft: "20px" }}>
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{
                      opacity: isVisible ? 1 : 0,
                      y: isVisible ? 1 : 0,
                    }}
                    className="text-6 text-white w-100 mb-0 mt-4"
                    transition={{ duration: 0.4, delay: 0.8 }}
                  ></motion.p>
                </VisibilitySensor>

                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{
                      opacity: isVisible ? 1 : 0,
                      y: isVisible ? 1 : 0,
                    }}
                    className="text-4 text-white w-100 mb-0"
                    transition={{ duration: 0.4, delay: 1 }}
                  >
                    {lang === "en" && (
                      <>
                        My ambition is to continue working in the IT sector,
                        where I can express my creativity and apply my skills to
                        important and challenging projects. I aim to work with
                        MERN or LAMP stacks, complex architectures, and
                        powerful, secure microservices. Above all{" "}
                        <b>never stop learning</b>.<br />
                        <br />
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        La mia ambizione è continuare a lavorare nel settore IT,
                        dove posso esprimere la mia creatività e applicare le
                        mie competenze su progetti importanti e stimolanti.
                        Voglio lavorare con stack MERN o LAMP, architetture
                        complesse, software a microservizi potenti e sicuri. Ma
                        soprattutto <b>non smettere mai di imparare</b>.
                      </>
                    )}
                  </motion.p>
                </VisibilitySensor>
              </div>
              <Spacer height="70" />
              <div
                className={classes.textCode1}
                style={{ color: "white" }}
              >{`}`}</div>
            </div>
            <div className="col-md-6">
              <iframe
                src="https://rocket.davidebalice.dev/"
                title="rocket"
                className={classes.rocketFrame}
              />

              {/*
                    <Rocket />
              */}
            </div>
          </div>
        </div>

        <Spacer height="20" />
      </section>
    </>
  );
};

export default AmbitionsHome;
